@if (
    localStorageService.isInitialized &&
    localizationService.isInitialized &&
    permService.permissionsLoaded
) {
    <div fileDrop>
        @if (fullApp) {
            <navbar></navbar>
            <div class="mainapp">
                <cerrix-tabs></cerrix-tabs>
            </div>
        }
    </div>
} @else {
    <div>
        <div style="position: absolute; left: 61px; top: 12px">
            <img src="/assets/img/logo.svg" width="200" height="50" />
        </div>
        <div class="fancy-loader"></div>
    </div>
}

<ng-template #singleComponent></ng-template>

<!-- If user loses session, this will kick in and show a modal so user can login without losing any data. -->
<login-modal></login-modal>
